<mat-card>
  <mat-card-header>
    <mat-card-title>
      {{pageType | capitalize }} Passage
    </mat-card-title>
  </mat-card-header>

  <form>
    <mat-card-content>
      <div>
        <mat-form-field>
          <input matInput placeholder="Title" [formControl]="passageForm.get('title')" required>
          <mat-error *ngIf="formService.controlHasError( passageForm.get('title'), 'required')">This field is required
          </mat-error>
        </mat-form-field>
        <mat-card-subtitle class="student">Content</mat-card-subtitle>
        <app-ck-editor [formControl]="passageForm.get('content')" [inline]="true" name="ckeditor"></app-ck-editor>
      </div>
    </mat-card-content>

    <mat-card-actions class="passage-actions" align="end">
      <button mat-raised-button color="primary" [disabled]="!passageForm.valid || isSubmitting" (click)="submitForm()">
        {{buttonName}}
      </button>
    </mat-card-actions>
  </form>
</mat-card>




